import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titlePipe',
  pure: true,
})
export class TitlePipe implements PipeTransform {
  transform(item: number): any {
    // TODO: find a better solution
    // problem is that the tenantConfig titles are
    // not real enums so the reverse diretion
    // number to value doesnt work
    let title = '';
    switch (item) {
      case 1:
        title = 'Dr.';
        break;
      case 2:
        title = 'Prof. Dr.';
        break;
      case 3:
        title = 'Dipl. Ing.';
        break;
      case 4:
        title = 'Dipl. med.';
        break;
      case 5:
        title = 'Dipl. Psych.';
        break;
      case 6:
        title = 'Dr. Dr.';
        break;
      case 7:
        title = 'Dr. med.';
        break;
      case 8:
        title = 'Prof. Dr. Dr.';
        break;
      case 9:
        title = 'Prof.';
        break;
      case 10:
        title = 'Prof. Dr. med.';
        break;
      case 11:
        title = 'Rechtsanwalt';
        break;
      case 12:
        title = 'Rechtsanwältin';
        break;
      case 13:
        title = 'Schwester';
        break;
      case 14:
        title = 'Dr. jur.';
        break;
      case 15:
        title = 'Firma';
        break;
      case 16:
        title = 'Freifrau';
        break;
      case 17:
        title = 'Freiherr';
        break;
      case 18:
        title = 'Gemeinschaftspraxis';
        break;
      case 19:
        title = 'Praxis';
        break;
      case 20:
        title = 'Priv.-Doz. Dr. med.';
    }
    return title;
  }
}
